import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useGetHiddenContent = (queryParams) => {
  const queryString = new URLSearchParams(queryParams).toString();

  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/content-hide/?${queryString}`;

  return useLazyRestQuery(requestUrl);
};

export default useGetHiddenContent;
